import LabServiceCollection from "@/collections/LabServiceCollection";
import ProjectStatusModel from "@/models/lab/ProjectStatusModel";

export default class ProjectStatusCollection extends LabServiceCollection {
  model() {
    return ProjectStatusModel;
  }

}
